/**
 * MissionTypeChart Component
 * 
 * Pie chart for mission type distribution
 */

import { FC } from 'react';
import Chart from 'react-apexcharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ApexOptions } from 'apexcharts';

interface MissionTypeChartProps {
    series: number[];
    labels: string[];
}

export const MissionTypeChart: FC<MissionTypeChartProps> = ({ series, labels }) => {
    const options: ApexOptions = {
        labels,
        colors: ['#0d9488', '#84cc16', '#22d3ee', '#a855f7', '#f97316'],
        legend: {
            show: true,
            position: 'right',
            labels: {
                colors: '#94a3b8',
            },
            itemMargin: {
                horizontal: 10,
                vertical: 10,
            },
        },
        dataLabels: {
            enabled: false,
        },
        chart: {
            background: 'transparent',
        },
        states: {
            hover: {
                filter: {
                    type: 'lighten',
                    value: 0.1,
                },
            },
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            y: {
                formatter: (val: number) => `${val}%`,
            },
        },
    };

    return (
        <Card className="bg-slate-900 border-slate-700">
            <CardHeader>
                <CardTitle className="text-white text-lg">Mission Type Distribution</CardTitle>
            </CardHeader>
            <CardContent className="flex items-center justify-center h-72">
                <Chart
                    type="pie"
                    width={450}
                    height={450}
                    series={series}
                    options={options}
                />
            </CardContent>
        </Card>
    );
};
